


































































































import Vue from 'vue'
import CategoryPostTree from '@/components/product/CategoryPostTree.vue'
import LessonsStats from '@/components/product/LessonsStats.vue'
import InstructorCard from '@/components/product/InstructorCard.vue'
import {
  getHeroSpacingClass,
  getThemeSettings,
  getSections,
  getProgressBarColor
} from '@/helper/index'

export default Vue.extend({
  components: {
    CategoryPostTree,
    LessonsStats,
    InstructorCard
  },
  props: {
    heroSection: {
      type: Object
    },
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    categoryTree: {
      type: Array
    },
    nextPost: {
      type: Object
    },
    completedPosts: Number,
    totalPosts: Number,
    postIdsCompleted: Set,
    categoryIdsCompleted: Set,
    courseCompleted: Boolean,
    productStarted: Boolean,
    logo: String
  },
  data() {
    return {
      styles: '',
      themeSettings: {},
      sections: {},
      progressColor: ''
    }
  },
  mounted() {
    this.themeSettings = getThemeSettings(this.product)
    this.sections = getSections(this.product)
    this.progressColor = getProgressBarColor(this.product)
  },
  computed: {
    brandLogoUrl(): string {
      return this.logo || this.$store.state.logoUrl
    },
    hero(): object {
      return this.sections?.hero
    },
    heroCustomBackground(): boolean {
      const background = this.hero?.background?.background
      if (background) {
        return true
      }
      return false
    },
    heroButton(): object {
      return this.hero?.button
    },
    buttonContent(): object {
      return this.heroButton?.content
    },
    showLogo(): boolean {
      if (this.themeSettings) {
        return this.themeSettings.logoPlacement === 'hero'
      }
      return false
    },
    heroSpacing(): string {
      if (this.sections?.hero?.background?.spacing) {
        return getHeroSpacingClass(this.sections.hero.background.spacing)
      }
      return null
    }
  },
  methods: {
    handleNextPostClick() {
      this.$emit('goToNextPost')
    }
  }
})
